<template>
  <wrap>
    <template #sidebar>
      <div class="carts-sidebar">
        <ui-button
          class="big-button"
          :border_r="6"
          color="dark-blue"
          size="40"
          @click="newChatModal.open()"
          :is_disabled="!merchant.is_enable_chatroom || permission_mes?.chatWithCreator?.permission!==100"
        >
          <svg-icon name="pen2" /> New
        </ui-button>
        <div class="search-box" v-if="!loading">
          <Search @onenter="search" @update="search" :placeholder_text="`Search creator name, tag, group`" />
          <tippy content="Set welcome message" placement="right" v-if="merchant.is_enable_chatroom">
            <ui-button :border_r="6" color="white" @click="welcomeMessageModal.open()">
              <svg-icon name="edit" />
            </ui-button>
          </tippy>
        </div>

        <ui-loading class="static" v-if="loading" />
        <div v-else class="users-list" v-for="(item, key) in searchResult" :key="key" :class="{ active: item.active }">
          <header @click="item.active = !item.active">
            <h3>{{ item.title }}</h3>
            <span>({{ item.users.length }})</span>
            <i class="unread" v-if="item.users.filter(user => user.unread_message_count !== 0).length !== 0"></i>
            <i v-if="item.users.length !== 0"><svg-icon name="arrow" /></i>
          </header>
          <slide-up-down v-model="item.active" class="users" :duration="300" v-if="item.users.length !== 0">
            <transition-group name="merchant-list" tag="div">
              <div
                class="user"
                v-for="user in item.users"
                :key="user.id"
                @click="openChat(user)"
                :class="{ current: user.slug === $route.params.id }"
              >
                <figure class="avatar">
                  <img :src="user.avatar" alt="avatar" />
                </figure>
                <div>
                  <h2>
                    <span class="name">{{ user.name }}</span>
                    <time v-if="item.title === 'Active' && user.latest_message">
                      {{ showDate(user.latest_message.created_at) }}
                    </time>
                    <span v-if="user.unread_message_count" class="unread-count">{{ user.unread_message_count }}</span>
                  </h2>
                  <p v-if="item.title === 'Active' && user.latest_message">
                    {{ removeHtml(user.latest_message.message_text) }}
                  </p>
                </div>
              </div>
            </transition-group>
          </slide-up-down>
        </div>
      </div>
    </template>
    <template #main>
      <div class="chats-wrap" :class="{'is-disable-chat': !merchant.is_enable_chatroom}">
        <header class="chats-header" v-if="$route.name === 'messaging-chats'">
          <h2>Chats</h2>
          <Alert v-if="!merchant.is_enable_chatroom" svgName="lock" className="yellow">
            <p>
              Your current plan does not have access to this feature. 
              <a :href="`mailto:anchor@motom.me?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a> 
              to upgrade your account
            </p>
          </Alert>
        </header>
        <header class="chats-header" style="height: 72px;" v-else>
          <el-avatar :size="44" :src="currentUser.avatar" />
          <div class="chats-header-info">
            <h3>{{ currentUser.name }}</h3>
            <ul v-if="creatorDetail.merchant_account_tags">
              <li v-for="(tag, index) in creatorDetail.merchant_account_tags.slice(0, 2)" :key="tag.id">
                <svg-icon name="tag" /><span>{{ tag.tag }}</span>
              </li>
              <li v-if="creatorDetail.merchant_account_tags.length > 2" class="more-tags">
                <svg-icon name="tag" /><span>+{{ creatorDetail.merchant_account_tags.length - 2 }}</span>
              </li>
            </ul>
          </div>
          <div class="icons">
            <a class="ico" v-if="creatorDetail.share_link && creatorDetail.anchor_page_status === 100" :href="`${creatorDetail.share_link}`" target="_blank">
              <svg-icon name="storefront" />
            </a>
            <span :class="['ico', permission_mes?.sendOnlyOrDisableChat?.permission!==100 && 'not-allowed-btn']" @click="openEdit">
              <svg-icon name="edit" />
            </span>
          </div>
        </header>
        
        <div class="chats-content" v-if="$route.name === 'messaging-chats'">
          <div class="no-users">
            <div>
              <h3 v-if="merchant.is_enable_chatroom">Send a message to start a chat</h3>
              <ui-button :is_disabled="permission_mes?.chatWithCreator?.permission!==100" v-if="merchant.is_enable_chatroom" @click="newChatModal.open()" color="dark-blue" size="40" :border_r="6">
                Send Message
              </ui-button>
              <div class="get-started" v-if="merchant.is_enable_chatroom && !welcomeMessage || permission_mes.editWelcomeMessage.permission !== 0">
                <h4>Getting Started item</h4>
                <div class="msg">
                  <svg-icon name="user-list" />
                  <p>
                    <label>Welcome message</label>
                    <span>{{ welcomeMessage ? '1' : '0' }}/1</span>
                  </p>
                  <ui-button color="dark-blue" size="32" @click="welcomeMessageModal.open()" :border_r="6">{{
                    welcomeMessage ? 'Edit' : 'Add'
                  }}</ui-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <chat-messaging
          v-if="$route.name === 'messaging-chats-detail' && token && currentUser.id"
          :user="currentUser"
          :portal_user="store.state.user_data"
          :chatroom_url="store.state.chatroom_url"
          :merchant="merchant"
          :token="token"
          :ajax="ajax"
          type="merchant"
          ref="chatRoom"
          :key="token"
          :is_disabled="isDisabledMessage"
          :deleted_announcement_ids="deletedAnnouncementIds"
          @get-message-history="getMessageHistory"
          @send-message="sendMessage"
        />
        <!-- @mark-as-read="markAsRead" -->

      </div>
    </template>
  </wrap>

  <new-chat ref="newChatModal" />
  <welcome-message ref="welcomeMessageModal" :merchant="merchant" />
  <edit-creator ref="edit" @save="saveEdit" />
</template>

<script setup>
import Wrap from '@/components/messaging/Wrap.vue';
import Search from '@/components/ui/Search.vue';
import ChatMessaging from '@/components/chat/ChatMessaging.vue';
import WelcomeMessage from '@/components/messaging/WelcomeMessage.vue';
import NewChat from '@/components/messaging/NewChat.vue';
import Alert from '@/components/settings/SettingAlert.vue';
import EditCreator from '@/components/creator/EditCreator.vue';
import log from '@/utils/Log';

import { ElAvatar } from 'element-plus';
import { ref, watch, getCurrentInstance, onMounted, computed } from 'vue';
import { useRouter,useRoute } from 'vue-router';
import { useStore } from 'vuex';
import moment from 'moment';
import Store from '@/store/index.js';

const router = useRouter();
const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;

// this.$store.state.user_data
const currentUser = ref({});
const merchant = ref({
  id: store.state.user_data.merchant_account_id,
  name: store.state.user_data.merchant_account.merchant_display_name,
  logo: store.state.user_data.merchant_account.brand_logo,
  is_enable_chatroom: store.state.user_data.merchant_account.is_enable_chatroom,
});
const token = ref('');
const last_active_date = ref('');
const chatRoom = ref(null);
const newChatModal = ref(null);
const creatorDetail = ref({});
const welcomeMessageModal = ref(null);
const searchWord = ref('');
const searchResult = ref([]);
const welcomeMessage = ref(false);
const loading = ref(true);
const isDisabledMessage = ref(false);
const edit = ref(null);
const deletedAnnouncementIds = ref([]);

const list = ref({
  active: {
    title: 'Active',
    active: false,
    users: [],
  },
  inactive: {
    title: 'Closed',
    active: false,
    users: [],
  },
  muted: {
    title: 'Send-only',
    active: false,
    users: [],
  },
});

const permission_mes= computed(()=>{
  return Store.state.user_data?.permission_list?.messagesAndAnnouncements;
})

const openEdit = () => {
  edit.value.open(creatorDetail.value);
};

const saveEdit = (data) => {
  getUsers();
  // getCreatorDetail(currentUser.value.anchor_creator_id);
};

const toSlug = (item) => {
  // Convert ID to base64 string
  const idBase64 = btoa(item.id.toString())
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  
  // If idBase64 is at least 8 characters, return the first 8
  if (idBase64.length >= 8) {
    return idBase64.substring(0, 8);
  }
  
  // Otherwise, encode the anchor_creator_id and append characters until we reach 8
  const nameBase64 = btoa(item.anchor_creator_id)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  
  // Calculate how many characters we need from the name
  const remainingChars = 8 - idBase64.length;
  
  // Use as many characters as available from nameBase64, up to the required amount
  const nameChars = nameBase64.substring(0, Math.min(remainingChars, nameBase64.length));
  
  // Return the combined slug
  return idBase64 + nameChars;
};

const getUsers = () => {
  const ajaxs = [
    ajax.get('/chatroom/get-creator-list?status=active'),
    ajax.get('/chatroom/get-creator-list?status=inactive'),
    ajax.get('/chatroom/get-creator-list?status=muted'),
  ];

  Promise.all(ajaxs).then((res) => {
    for (let i = 0; i < res.length; i++) {
      res[i].data.data.sort((a, b) => {
        if (!a.latest_message && !b.latest_message) return 0;
        if (!a.latest_message) return 1;
        if (!b.latest_message) return -1;
        
        return new Date(b.latest_message.created_at) - new Date(a.latest_message.created_at);
      });

      res[i].data.data.forEach((item) => {
        item.slug = toSlug(item);
        item.avatar = item.avatar ? item.avatar : require('@/assets/images/user.png');

        if (router.currentRoute.value.params.id) {
          if (item.slug === router.currentRoute.value.params.id) {
            currentUser.value = item;
            isDisabledMessage.value = item.chat_status === 'inactive';
            getCreatorDetail(item.anchor_creator_id);
          }
        }
      });
    }

    const urlSlug = router.currentRoute.value.params.id;

    Object.keys(list.value).forEach((key, index) => {
      list.value[key].users = res[index].data.data;

      if (urlSlug && list.value[key].users.find((user) => user.slug === urlSlug)) {
        list.value[key].active = true;
      }
    });

    if (!urlSlug) list.value.active.active = true;

    searchResult.value = list.value;

    loading.value = false;

    if (router.currentRoute.value.params.id) {
      getToken(router.currentRoute.value.params.id);
    }
  });


};

const removeHtml = (text) => {
  return text.replace(/<[^>]*>?/g, '');
};

const showDate = (date) => {
  const local = moment.utc(date).local();

  if (moment().format('YYYY-MM-DD') === moment(local).format('YYYY-MM-DD')) 
    return moment(local).format('h:mma');
  else if (moment().format('YYYY') === moment(local).format('YYYY'))
    return moment(local).format('MM/DD');
  else 
    return moment(local).format('MM/DD/YYYY');
};

const openChat = (user) => {
  router.push('/messaging/chats/' + user.slug);
};

const getDeletedAnnouncementIds = () => {
  ajax.get('/chatroom/get-deleted-chatroom-announcement-list').then((res) => {
    deletedAnnouncementIds.value = res.data.data;
  });
};

const getToken = (slug) => {
  let userId = null;
  
  Object.keys(list.value).forEach((key) => {
    const users = list.value[key].users;
    const user = users.find(u => u.slug === slug);
    if (user) {
      userId = user.id;
    }
  });
  
  if (!userId) {
    console.error('User not found for slug:', slug);
    return;
  }
  
  ajax.post('/chatroom/get-auth-key', { creator_portal_user_id: userId.toString() }).then((res) => {
    token.value = res.data.data.auth_key;
    last_active_date.value = res.data.data.creator_last_active_time;
  });
};

const getWelcomeMessage = () => {
  ajax.get('/chatroom/get-welcome-message').then((res) => {
    if (res.data.data) {
      welcomeMessage.value = true;
    }
  });
};

const sendMessage = (msg) => {
  // console.log('sendMessage', msg);
  // const currentMerchantIndex = list.value.findIndex(item => item.active);
  
  // if (currentMerchantIndex > 0) {
  //   const currentMerchant = list.value.splice(currentMerchantIndex, 1)[0];
  //   list.value.unshift(currentMerchant);
  // }
  const currentMerchantIndex = list.value.active.users.findIndex(item => item.id === currentUser.value.id);
  if (currentMerchantIndex > 0) {
    const currentMerchant = list.value.active.users.splice(currentMerchantIndex, 1)[0];
    list.value.active.users.unshift(currentMerchant);
  }
};

const getMessageHistory = (id = '') => {
  if (!currentUser.value || !currentUser.value.id) {
    console.error('Current user not found');
    return;
  }
  
  let api = '/chatroom/get-message-history?creator_portal_user_id=' + currentUser.value.id;

  
  if (id) {
    api += '&last_message_id=' + id;
  }

  ajax.get(api).then((res) => {
    markAsRead();
    chatRoom.value.syncMessages(res.data.data);
  });
};

const markAsRead = () => {
  const id = currentUser.value.id;
  Object.keys(list.value).forEach((key) => {
    const users = list.value[key].users;
    users.forEach((user) => {
      if (user.id === Number(id)) {
        store.state.unread_message_count = store.state.unread_message_count - user.unread_message_count;
        user.unread_message_count = 0;
        eventBus.emit('update-unread-message-count', user.unread_message_count);
      }
    });
  });

};

const search = (word) => {
  searchWord.value = word;
};

const getCreatorDetail = (id) => {
  ajax.get('/creator/get-creator-detail?creator_user_id=' + id).then((res) => {
    creatorDetail.value = res.data.data;
  });
};

watch(searchWord, (word) => {
  if (word) {
    const obj = JSON.parse(JSON.stringify(list.value));
    for (let key in obj) {
      obj[key].users = obj[key].users.filter((user) => {
        return user.name.toLowerCase().includes(word.toLowerCase());
      });
    }

    searchResult.value = obj;
  } else {
    searchResult.value = list.value;
  }
});

watch(
  () => router.currentRoute.value.params.id,
  (slug) => {
    if (slug) {
      Object.keys(list.value).forEach((key) => {
        const users = list.value[key].users;
        const user = users.find(user => user.slug === slug);
        
        if (user) {
          currentUser.value = user;
          isDisabledMessage.value = user.chat_status === 'inactive';
          getToken(slug);
          getCreatorDetail(user.anchor_creator_id);
        }
      });
    }
  }
);

onMounted(() => {
  if(permission_mes.value?.manageMessaging.permission === 0){
    router.push('/messaging/announcements');
  }

  log('BlueViolet', 'user data', store.state.user_data);
  getWelcomeMessage();
  getUsers();
  getDeletedAnnouncementIds();
});
</script>

<style lang="scss">
.chats-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .message-wrap {
    max-height: calc(100vh - 76px);
  }

  &.is-disable-chat {
    .no-messages h3 {
      display: none;
    }
  }
}

.chats-header {

  height: 60px;
  display: flex;
  align-items: center;

  h2 {
    font: var(--font-demi-24);
    color: var(--black-90);
    flex: 1;
  }

  .ui-alert {
    margin: 0;
  }

  .chats-header-info {
    padding-left: 12px;
    flex: 1;
    
    h3 {
      font: var(--font-demi-20);
      line-height: 1;
      color: var(--black-90);
    }

    ul {
      display: flex;
      gap: 6px;
      padding: 4px 0 0;

      li {
        font-size: 12px;
        color: var(--black-90);
        padding: 3px 6px;
        border-radius: 4px;
        background-color: var(--black-10);
        display: flex;
        align-items: center;
        gap: 2px;

        svg {
          height: 12px;
          width: 12px;
          fill: var(--black-75);
        }
        
        
      }
    }
  }

  .icons {
    display: flex;
    gap: 4px;

    .ico {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      height: 28px;
      width: 28px;
      cursor: pointer;
      transition: all 0.2s ease;
      border-radius: 4px;

      svg {
        height: 14px;
        width: 14px;
        fill: var(--black-75);
      }

      &:hover {
        background-color: var(--Neu-20);
        color: var(--dark-blue);
      }
    }

    .not-allowed-btn{
      cursor: not-allowed;
      pointer-events: none;
      opacity: .5;
    }
  }
}

.carts-sidebar {
  padding: 8px 16px 16px;

  .big-button {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      height: 18px;
      width: 18px;
      margin-right: 8px;
    }

    &:hover {
      border-color: var(--PB-80);
      background-color: var(--PB-80);
    }

    &.disabled {
      border-color: var(--neutral);
      color: var(--black-40);
    }
  }

  .search-box {
    display: flex;
    margin: 12px 0;

    .ui-search-input {
      flex: 1;
      margin-right: 8px;
    }

    .ui-button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: var(--black-90);
      transition: all 0.2s ease;
      padding: 0 10px;

      svg {
        height: 14px;
        width: 14px;
        margin: 0;
      }

      &:hover {
        color: var(--dark-blue);
      }
    }
  }

  .users-list {
    margin: 12px 0;
    border-radius: 6px;
    border: 1px solid var(--black-20);

    & > header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      height: 40px;
      cursor: pointer;

      h3 {
        font: var(--font-med-14);
        color: var(--black-90);
        flex: 1;
      }

      span {
        font-size: 12px;
        color: var(--black-75);
      }

      .unread {
        margin-left: 8px;
        border-radius: 50%;
        height: 8px;
        width: 8px;
        background-color: var(--red);
      }

      svg {
        height: 10px;
        width: 10px;
        fill: var(--black-50);
        transition: all 0.2s ease;
        margin-left: 10px;
      }

      &:hover svg {
        fill: var(--dark-blue);
      }
    }

    &.active {
      header {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    .users {
      overflow: hidden;

      .user {
        display: flex;
        align-items: center;
        padding: 0 16px;
        cursor: pointer;
        height: 48px;
        position: relative;

        &:first-child {
          z-index: 3;
        }

        .avatar {
          width: 30px;
          min-width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          box-sizing: content-box;
          border: 1px solid var(--black-20);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        div {
          width: calc(100% - 40px);

          & > p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
            color: var(--black-50);
          }
        }

        h2 {
          display: flex;
          align-items: center;
          
          time {
            font-size: 11px;
            color: var(--black-50);
            margin-left: 4px;
          }
        }

        .name {
          font: var(--font-med-16);
          color: var(--black-90);
          font: var(--font-med-14);
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:hover {
          background-color: var(--bg-10);
        }

        .unread-count {
          color: transparent;
          margin-left: 8px;
          border-radius: 50%;
          height: 8px;
          width: 8px;
          overflow: hidden;
          background-color: var(--blue);
        }

        &.current {
          background-color: var(--Neu-20);
        }
      }

      & > div:first-child {
        border-top: 1px solid var(--black-10);
      }
    }
  }
}

.chats-content {
  flex: 1;
  overflow-y: auto;
  background-color: var(--bg-10);
}

.no-users {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  padding: 0 16px;
  color: var(--black-90);
  max-width: 700px;
  margin: 0 auto;

  h3 {
    font: var(--font-med-30);
    margin-bottom: 16px;
  }

  .get-started {
    border-radius: 10px;
    background-color: var(--white);
    box-shadow: var(--bot-2dp);
    margin: 24px 0;
    padding: 16px;
    min-width: 328px;

    h4 {
      font: var(--font-med-16);
      margin-bottom: 10px;
      color: var(--black-90);
      text-align: left;
    }
  }

  .msg {
    border-radius: 8px;
    box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: flex;
    align-items: center;

    svg {
      height: 42px;
      width: 42px;
      fill: var(--dark-blue);
      margin-right: 10px;
    }

    p {
      flex: 1;
      text-align: left;

      label {
        display: block;
        font: var(--font-med-14);
        color: var(--black-90);
      }

      span {
        font: var(--font-med-12);
        color: var(--black-50);
      }
    }
  }
}

.merchant-list-move,
.merchant-list-enter-active,
.merchant-list-leave-active {
  transition: all 0.5s ease;
}

.merchant-list-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.merchant-list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.merchant-list-move {
  transition: transform 0.5s ease;
}
</style>
